import { Tooltip, TooltipProps, styled, tooltipClasses } from '@mui/material';
import { UITooltipProps } from './UITooltip.types';

export const CustomTooltip = styled(
  ({ className, arrow, ...props }: TooltipProps & UITooltipProps) => (
    <Tooltip {...props} arrow={arrow} classes={{ popper: className }} />
  )
)(({ theme, color = 'info', arrow }) => ({
  ...(arrow && {
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette[color].light,
    },
  }),
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette[color].light,
    color: theme.palette[color].contrastText,
  },
}));
